<template>
    <div class="product-tab-content">

        <p>
            Bij dit {{ product.base_name }} abonnement van {{ product.provider_name }} is een tv-pakket inbegrepen.
            Vrijwel alle populaire Nederlandse zenders (zoals NPO, RTL en SBS) zitten in elk tv-pakket.
            <!-- <a @click="$emit('channeldialog')" class="channel-link">Bekijk welke zenders in dit pakket zitten.</a> -->
        </p>

        <product-info-table :rows="tvRows">
            <template v-slot:row-tv>
                <product-info-property icon="tv">
                    {{ product.tv.channel_count }} tv-zenders
                </product-info-property>
                <product-info-property icon="tv">
                    {{ product.tv.channel_count_hd }} HD-zenders
                </product-info-property>
                <product-info-property icon="tv" v-if="product.tv.extra.tv_app">
                    Live TV App
                </product-info-property>
                <product-info-property icon="tv" v-if="product.tv.extra.video_on_demand">
                    Video on Demand
                </product-info-property>
            </template>

            <template v-slot:row-packages>
                <product-info-property icon="tv" v-for="tvProduct in product.tv.enabled" :key="tvProduct.id">
                    {{ tvProduct.name }}
                    <span
                        v-if="(tvProduct.price_initial === 0 || tvProduct.price_initial === null) && (tvProduct.price_monthly === 0 || tvProduct.price_monthly === null)">
                        (inbegrepen)
                    </span>
                    <span v-if="tvProduct.price_monthly > 0"> ({{ toCurrencyEur(tvProduct.price_monthly) }} per
                        maand)</span>
                </product-info-property>
            </template>
        </product-info-table>
    </div>

</template>

<script setup>
import ProductInfoTable from 'vue-elements/product-info/ProductInfoTable.vue';
import ProductInfoProperty from 'vue-elements/product-info/ProductInfoProperty.vue';
import { computed } from 'vue';

const prps = defineProps({
    product: Object,
});

const tvRows = computed(() => {
    let rows = [
        {
            id: 'tv',
            label: 'TV',
        },
        {
            id: 'packages',
            label: 'Pakketten',
        },
    ];

    return rows;
});
</script>